import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['meeting-template'] as const;

export const meetingQuery = {
  base: baseKey,
  getMeetingTypes: [...baseKey, 'meeting-types'],
} as const;
